/**
 * Saving a file the server builds on request. Fetched first so the screen can say it is
 * being prepared and can say why when it cannot be, instead of leaving the estimator on
 * a blank error page.
 */
import { ApiError } from "@/api/client";

export async function saveFile(url: string, filename: string): Promise<void> {
  const response = await fetch(url);
  if (!response.ok) {
    let detail = response.statusText || `request failed with ${response.status}`;
    try {
      const body = (await response.json()) as { detail?: unknown };
      if (typeof body.detail === "string") {
        detail = body.detail;
      }
    } catch {
      // Not JSON; the status text will do.
    }
    throw new ApiError(response.status, detail);
  }
  const blob = await response.blob();
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoked a moment later: some browsers start the save after the click returns.
  setTimeout(() => URL.revokeObjectURL(href), 10_000);
}

/** "the-ellis-arch" from "The Ellis ARCH.pdf": a base for the names of what is saved. */
export function baseName(filename: string | undefined): string {
  const stem = (filename ?? "take-off").replace(/\.pdf$/i, "");
  return (
    stem
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "") || "take-off"
  );
}
